import { Component, OnInit, Inject } from '@angular/core';
import { utils, read } from 'xlsx';
import { MAT_DIALOG_DATA } from '@angular/material';
import { CWSMSAPIService } from '../cwsmsapi.service';

@Component({
  selector: 'app-file-import',
  templateUrl: './file-import.component.html',
  styleUrls: ['./file-import.component.css']
})
export class FileImportComponent implements OnInit {

	importedFileContent: any = [];
	displayedFileContent: any = [];
	phoneNumberList: any = [];
	currentFileName: string = "";
	columnHeaders: any = [];
	selectedColumns: any = [];

	currentTablePage: any = 0;
	maxTablePage: any = 0;
	perPage: any = 1000;
	e: any;

	defaultCountryCode: any = "+47";
	preferredCountries: any = ['no', 'se', 'dk'];
	importedFileContentImportFlag: any = [];

	constructor(@Inject(MAT_DIALOG_DATA) public data: any, public cwsms: CWSMSAPIService) {
		this.e = data.e;
	}

	onChangedDefaultCountry(event) {
		this.defaultCountryCode = event;
		console.log(event);
		this.handleFile(this.e);
	}

	isColumnValid(column) {
		if (column !== undefined && column.valid) {
			return true;
		}
		return false;
	}

	ngOnInit() {
		this.handleFile(this.e);
	}

	getFirstSheet(workbook) {
		if ("Sheets" in workbook) {
			for (var s in workbook.Sheets) {
				return workbook.Sheets[s];
			}
		}
		return null;
	}

	formatPhoneNumber(phoneNumber) {
		// Remove all characters except numbers
		var formattedPhoneNumber = phoneNumber.replace(/[^0-9]/g, '');
	
		// Remove leading 00's if present
		if (formattedPhoneNumber.startsWith("00")) {
			formattedPhoneNumber = formattedPhoneNumber.substring(2);
		}
		return formattedPhoneNumber;
	}

	isValidPhoneNumber(num) {
		var formattedNum = this.formatPhoneNumber(num);
		if (!isNaN(formattedNum) && formattedNum.toString().length > 6) {
			return true;
		}
		return false;
	}

	handleFile(e) {
		console.log(e);
		var files = e.target.files, f = files[0];
		var reader = new FileReader();
		reader.onload = (e) => {
			var target: any = e.target;
			var data = target.result;
			var wb = read(data, {type: 'binary'});
			var ws = this.getFirstSheet(wb);
			var jsonData = utils.sheet_to_json(ws);
			this.importedFileContent = [];

			this.columnHeaders = [];
			this.selectedColumns = [];
			for (var line of jsonData) {
				for (var i in line) {
					this.columnHeaders.push({
						text: i,
						valid: true,
						count: 0
					});
					this.selectedColumns.push(true);
				}
				break;
			}

			var columnNumber = 0, rowNumber = 0, rowLength = this.columnHeaders.length;
			for (var line of jsonData) {
				var newLine = [];
				columnNumber = 0;
				for (var i in line) {
					if (this.isValidPhoneNumber(line[i])) {
						// Check if this number contains a country code
						if (!line[i].toString().startsWith("+")) {
							newLine.push({
								text: this.defaultCountryCode+line[i],
								valid: true,
								import: true
							});
							this.importedFileContentImportFlag[rowNumber*rowLength+columnNumber] = true;
						} else {
							newLine.push({
								text: line[i],
								valid: true,
								import: true
							});
							this.importedFileContentImportFlag[rowNumber*rowLength+columnNumber] = true;
						}
						this.columnHeaders[columnNumber].count++;
					} else {
						newLine.push({
							text: line[i],
							valid: false,
							import: false
						});
						this.columnHeaders[columnNumber].valid = false;
						this.selectedColumns[columnNumber] = false;
						this.importedFileContentImportFlag[rowNumber*rowLength+columnNumber] = false;
					}
					columnNumber++;
				}
				this.importedFileContent.push(newLine);
				rowNumber++;
			}

			this.maxTablePage = Math.ceil(this.importedFileContent.length / this.perPage);

			this.updateDisplayedFileContent();
		};
		reader.readAsBinaryString(f);
	}

	nextTablePage() {
		if (this.currentTablePage < this.maxTablePage - 1) {
			this.currentTablePage++;
			this.updateDisplayedFileContent();
		}
	}

	previousTablePage() {
		if (this.currentTablePage > 0) {
			this.currentTablePage--;
			this.updateDisplayedFileContent();
		}
	}

	setTablePage(page) {
		this.currentTablePage = page;
		this.updateDisplayedFileContent();
	}

	updateDisplayedFileContent() {
		this.displayedFileContent = [];
		for (var i = 0; i < this.perPage; i++) {
			var index = this.currentTablePage*this.perPage + i;
			this.displayedFileContent.push(this.importedFileContent[index]);
		}
	}

	columnSelectChange(i) {
		var rl = this.selectedColumns.length;
		for (var r = 0; r < this.importedFileContent.length; r++) {
			this.importedFileContentImportFlag[r*rl+i] = this.selectedColumns[i];
		}
	}

	rowsSelectedInColumn(c) {
		var ret = 0;
		var rl = this.selectedColumns.length;
		for (var r = 0; r < this.importedFileContent.length; r++) {
			if (this.importedFileContentImportFlag[r*rl+c]) {
				ret++;
			}
		}
		return ret;
	}

	importSelectedColumns() {
		var toReturn = [];

		var r = 0, c = 0, rl = this.selectedColumns.length;
		for (var n in this.importedFileContent) {
			var currentRow = this.importedFileContent[n];
			c = 0;
			for (var i in this.selectedColumns) {
				if (/*this.selectedColumns[i] &&*/ i in currentRow && currentRow[i].valid && this.importedFileContentImportFlag[r*rl+c]) {
					toReturn.push(currentRow[i].text);
				}
				c++;
			}
			r++;
		}
		return toReturn;
	}
}



// WEBPACK FOOTER //
// ./src/app/file-import/file-import.component.ts